import React from "react";
import { string } from "prop-types";

import contentViewTypes from "../../constants/contentViewTypes";
import { useUIStoreData } from "../../utilities/mobx/storeHooks";
import HomeClaimCTA from "../HomeClaimCTA";
import HomeClaimCTAMinimal from "../HomeClaimCTAMinimal";
import HomeClaimHeader from "../HomeClaimHeader";
import HomeClaimHeaderMinimal from "../HomeClaimHeaderMinimal";
import Valuation from "../Valuation";
import ValuationError from "../ValuationError";
import ValuationLoading from "../ValuationLoading";
import ValuationMinimal from "../ValuationMinimal";
import * as S from "./styled";

const HomeClaimContent = ({ className }) => {
  const { contentView, showMinimalComponentTreatment } = useUIStoreData();

  const minimalContentViews = {
    [contentViewTypes.cta]: <HomeClaimCTAMinimal />,
    [contentViewTypes.valuation]: <ValuationMinimal />,
    [contentViewTypes.valuationError]: <ValuationError />,
    [contentViewTypes.valuationLoading]: <ValuationLoading />
  };

  const defaultContentViews = {
    [contentViewTypes.cta]: <HomeClaimCTA />,
    [contentViewTypes.valuation]: <Valuation />,
    [contentViewTypes.valuationError]: <ValuationError />,
    [contentViewTypes.valuationLoading]: <ValuationLoading />
  };

  const contentHeader = showMinimalComponentTreatment ? (
    <HomeClaimHeaderMinimal />
  ) : (
    <HomeClaimHeader />
  );

  const contentViews = showMinimalComponentTreatment
    ? minimalContentViews
    : defaultContentViews;

  return (
    <S.Content
      className={className}
      showMinimalComponentTreatment={showMinimalComponentTreatment}
    >
      {contentHeader}
      {contentViews[contentView]}
    </S.Content>
  );
};

HomeClaimContent.propTypes = {
  className: string
};

HomeClaimContent.defaultProps = {
  className: ""
};

export default HomeClaimContent;
